<template>
  <div>
    <v-card>
      <v-card-text>
        <v-text-field
            v-model="demande"
            label="N° de demande"
            type="text"
            readonly
            disabled
        ></v-text-field>
        <v-text-field
            v-model="dateDemande"
            label="Date de la demande"
            type="text"
            readonly
            disabled>
        </v-text-field>
        <v-text-field
            class="mr-5"
            label="Numéro du lot"
            v-model="lot"
            readonly
            disabled
        ></v-text-field>
        <v-text-field
            class="mr-5"
            label="Type de prestation"
            v-model="prestation"
            readonly
            disabled
        ></v-text-field>
        <v-text-field
            v-model="objetDemande"
            label="Objet de la demande"
            type="texte"
            readonly
            disabled
        ></v-text-field>
        <div class="d-flex justify-end mt-5">
          <v-btn color="primary" @click="next">Suivant</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "DepotCommandeObjet",
  props: {
    selectedDemande:
        { type: Object, required: true }
  },
  data() {
    return {
      demande: "",
      dateDemande: null,
      lot: null,
      prestation: null,
      objetDemande: null,
    };
  },

  created() {
    this.demande = this.selectedDemande?.numero;
    this.dateDemande = this.selectedDemande?.createdAt.split('T')[0];
    this.lot = this.selectedDemande?.lot;
    this.prestation = this.selectedDemande?.prestation?.label;
    this.objetDemande = this.selectedDemande?.objet;
  },

  methods: {
    next() {
      const stepData = {
        demande: this.demande,
        dateDemande: this.dateDemande,
        lot: this.lot,
        prestation: this.prestation,
        objetDemande: this.objetDemande,
      };
      this.$emit("onNext", stepData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>